export class HarvestIdRequest {
    harvestId: number;
    plantId: number;

    constructor(harvestId: number,plantId: number){
        this.harvestId = harvestId;
        this.plantId = plantId;
    }
}